import { Flex, FlexProps, Text } from '@chakra-ui/react'
import { ReactNode } from 'react'

import { NetworkErrorIcon } from '../Icons/NetworkErrorIcon'

export type WidgetErrorProps = {
  children?: ReactNode
} & FlexProps

export const WidgetError = ({ children, ...props }: WidgetErrorProps) => {
  return (
    <Flex
      direction="column"
      alignItems="center"
      justify="center"
      rounded="lg"
      p="3"
      border="1px"
      borderColor="presets.yellow.30"
      backgroundColor="presets.yellow.5"
      {...props}
    >
      <NetworkErrorIcon
        boxSize={6}
        color="presets.yellow.90"
        w="22px"
        h="22px"
        mb={13}
        mt={3}
      />
      {children ? (
        <Text variant="error">{children}</Text>
      ) : (
        <Text variant="error">Something went wrong...</Text>
      )}
    </Flex>
  )
}
